
import LocomotiveScroll from "locomotive-scroll";
import { debounce } from "throttle-debounce";
import g from "../globals/variables";

const Scroll = {

  init: () => {
    Scroll.initScroll();
    Scroll.reinitScroll();
    window.addEventListener("resize", debounce(60, Scroll.reinitScroll));
    if (window.innerWidth >= g.resolution.m) window.addEventListener("load", Scroll.reinitScroll);
  },

  initScroll: () => {
    g.scroll = new LocomotiveScroll({
      el: g.el.layout,
      // lerp: 0.08,
      smooth: true,
      smoothMobile: false,
      // scrollbarContainer: g.el.layout,
      class: "in-view",
      initClass: "scroll",
      scrollingClass: "scroll--scrolling",
      draggingClass: "scroll--dragging",
      smoothClass: "scroll--smooth",
      scrollbarClass: "scrollbar",
      // scrollFromAnywhere: true,
    });
  },

  reinitScroll: () => {
    g.scroll.destroy();
    document.querySelectorAll("[data-scroll-section], [data-scroll]").forEach(item => item.removeAttribute("style"));
    Scroll.setProps(window.innerWidth >= g.resolution.m ? "desktop" : "mobile");
    g.scroll.init();
    g.scroll.update();
  },

  setProps: (device) => {
    if (device === "desktop") {
      g.scroll.smooth = true;
      if (g.el.uploadNavigation) g.el.uploadNavigation.setAttribute("data-scroll-sticky", "");
    } else {
      g.scroll.smooth = false;
      if (g.el.uploadNavigation) {
        g.el.uploadNavigation.removeAttribute("data-scroll-sticky");
        g.el.uploadNavigation.style.position = "absolute";
        g.el.uploadNavigation.style.top = "0";
        setTimeout(() => {
          g.el.uploadNavigation.removeAttribute("style");
        }, 1600);
      }
    }
  },
};

export default Scroll;
